import { ReactNode } from "react";

type Step = {
  number: number;
  icon: ReactNode;
  title: string;
  description: string | ReactNode;
  active?: boolean;
};

type ServiceStepsProps = {
  steps: Step[];
  titleColor?: string;
  iconBackground?: string;
};

const ServiceSteps = ({
  steps,
  titleColor = "text-[#032C6D]",
  iconBackground = "bg-[#fff3e0]",
}: ServiceStepsProps) => {
  return (
    <div className="flex justify-center items-stretch gap-12 mt-[60px] mb-[100px]">
      {steps.map((step, idx) => (
        <div key={idx} className="flex items-center ">
          <div className={`relative w-[220px] p-6 rounded-lg  bg-white shadow-md`}>
            {/* Number badge */}
            <p className={`text-right text-[2.8rem] mb-6 font-extrabold text-gray-300`}>
              {step.number}
            </p>

            {/* Icon */}
            <div
              className={`w-[48px] h-[48px] rounded-lg flex items-center justify-center mb-4 ${iconBackground}`}
            >
              {step.icon}
            </div>

            {/* Title */}
            <h3 className={`text-[2rem] font-bold mb-2 ${titleColor}`}>{step.title}</h3>

            {/* Description */}
            <p className="text-[1.3rem] text-gray-5 leading-[1.5]">{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceSteps;
